import React from 'react';

const AdminHeader = () => {
  return (
    <div className="admin-header">
      <h1>Admin Dashboard</h1>
      <p>Manage users, shifts, and driver posts</p>
    </div>
  );
};

export default AdminHeader;
